import { TinyColor } from '@ctrl/tinycolor';
export var fade = function fade(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.08;
  var newColor = new TinyColor(color);
  newColor.setAlpha(alpha);
  return newColor.toRgbString();
};
export var darken = function darken(color) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;
  var newColor = new TinyColor(color);
  return newColor.shade(ratio * 100).toRgbString();
};
export var lighten = function lighten(color) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  var newColor = new TinyColor(color);
  return newColor.tint(ratio * 100).toRgbString();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/util/colorManipulation.js
// module id = 518
// module chunks = 0